/**
 * @file コンポーネント：協賛企業リスト ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Partnerlist = (props) => {
    // Presenterに渡す
    return <Presenter list={props.list} />;
};
